/**
 * @type {Object}
 * @property {array}  data  Item data
 */
const initialState = {
    salesPromotionData: []
};

/**
 * 
 * @param {Object} state    Initial state of store 
 * @param {Object} action   action data
 * @returns {Object} newState 
 */
const reducerSalesPromotion = (state = initialState, action) => {
    const newState = { ...state }
    switch (action.type) {
        case 'FETCH_SALES_PROMOTION_DATA':
            var { data } = action;
            newState.salesPromotionData = data;
            break;

        default:
            break;
    }
    return newState;
}

export default reducerSalesPromotion;